import React, { useEffect, useState } from 'react';
import { fetchWabaInfo, WabaInfo } from '../../../services/whatsapp/wabaService';

export default function NumbersTab() {
  const [waba, setWaba] = useState<WabaInfo | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchWabaInfo().then(data => {
      setWaba(data.waba);
      setLoading(false);
    }).catch(err => {
      console.error(err);
      setLoading(false);
    });
  }, []);

  if (loading) return <div className="text-wa-muted">Loading numbers...</div>;
  if (!waba) return <div className="text-red-400">Failed to load numbers.</div>;

  return (
    <div>
      <h3 className="text-white font-medium mb-4">Phone Numbers</h3>
      <p className="text-wa-muted text-sm mb-6">Numbers associated with your WhatsApp Business Account.</p>
      
      <table className="w-full text-left border-collapse">
        <thead>
          <tr className="border-b border-wa-border text-wa-muted text-sm">
            <th className="py-2 px-4">Name</th>
            <th className="py-2 px-4">Number</th>
            <th className="py-2 px-4">Quality Rating</th>
            <th className="py-2 px-4">Messaging Tier</th>
          </tr>
        </thead>
        <tbody>
          {waba.phone_numbers?.data?.map(num => (
            <tr key={num.id} className="border-b border-wa-border hover:bg-wa-surface2 transition-colors">
              <td className="py-3 px-4 text-white">{num.name}</td>
              <td className="py-3 px-4 text-wa-muted font-mono">{num.display_phone_number}</td>
              <td className="py-3 px-4">
                <span className={`px-2 py-1 rounded text-xs ${
                  num.quality_rating === 'GREEN' ? 'bg-green-900 text-green-300' :
                  num.quality_rating === 'YELLOW' ? 'bg-yellow-900 text-yellow-300' :
                  'bg-red-900 text-red-300'
                }`}>
                  {num.quality_rating}
                </span>
              </td>
              <td className="py-3 px-4 text-white font-medium">{num.messaging_limit_tier}</td>
            </tr>
          ))}
          {(!waba.phone_numbers?.data || waba.phone_numbers.data.length === 0) && (
            <tr>
              <td colSpan={4} className="py-6 px-4 text-center text-wa-muted">No numbers found.</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
